///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard = abcsetup.dashboard || {};
abcsetup.dashboard.vendor = abcsetup.dashboard.vendor || {};

abcsetup.dashboard.vendor.frontstore = abcsetup.dashboard.vendor.frontstore || {};
abcsetup.dashboard.vendor.prdocs = abcsetup.dashboard.vendor.prdocs || {};
abcsetup.dashboard.vendor.image_requests = abcsetup.dashboard.vendor.image_requests || {};
abcsetup.dashboard.vendor.item_maintenance = abcsetup.dashboard.vendor.item_maintenance || {};
abcsetup.dashboard.vendor.promo_plans = abcsetup.dashboard.vendor.promo_plans || {};
abcsetup.dashboard.vendor.three_pm = abcsetup.dashboard.vendor.three_pm || {};
abcsetup.dashboard.vendor.ncm = abcsetup.dashboard.vendor.ncm || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard.vendor = {
    init: function () {
        if (abcsetup.userOrg.three_pm === 'Y') {
            // Cheap hack to add vendor_3pm specific dashboard styles
            $('body').addClass('vendor_3pm');
        }

        // Clear session storage because GNP Central Banner Ad Promo type uses sessionStorage variables
        // This typically isn't an issue with Users, but RI QA team testing in the same tab are having issues with data carrying over
        sessionStorage.clear();

        // Increase the height of the panel when expanded
        $(document).on('click', '.panel a.expand', function () {
            var panel = $(this).closest('.panel');
            var bhoechieTab = panel.find('.bhoechie-tab-content'); 

            if (panel.hasClass('expanded')) {
                bhoechieTab.css('min-height', '85vh');
            } else if (!panel.hasClass('expanded')) {
                bhoechieTab.css('min-height', '');
            }

            return false;
        });

        // Promo Plan delete button clicked
        $(document).on('click', '#app_data_tables_promo_promo_plan_data_table_wrapper .btn-delete-promo_plan', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Delete Promo Plan', 'Are you sure you want to delete this promo plan?', function (resp) {
                if (resp) {
                    abcsetup.dashboard.vendor.promo_plans.delete(_this.data('id'));
                }
            });
        });

        // Outstanding items delete button clicked
        $(document).on('click', '#frontstore_panel .btn-delete-workflow', function () {
            var _this = $(this);

            if (_this.data('initial_class') == 'field_team' && abcsetup.userRole.class == 'vendor') {
                // Vendor needs to provide a reason for Deleting this Workflow
                abcsetup.alerts.prompt('Delete Workflow Task', 'Please provide a reason for deleting this Workflow Task?', function (resp) {
                    if (resp[0]) {
                        abcsetup.dashboard.vendor.frontstore.deleteWorkflow(_this.data('id'), resp[1]);
                    }
                }, true);
            } else {
                abcsetup.alerts.confirm('Delete Workflow Task', 'Are you sure you want to delete this workflow task?', function (resp) {
                    if (resp) {
                        abcsetup.dashboard.vendor.frontstore.deleteWorkflow(_this.data('id'));
                    }
                });
            }
        });

        // New item in process - delete button clicked
        $(document).on('click', '#new_items_panel .btn-delete', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Delete Item', 'Are you sure you want to delete this item?', function (resp) {
                if (resp) {
                    abcsetup.dashboard.vendor.frontstore.delete(_this.data('id'));
                }
            });
        });

        // Cancel Maintenance button clicked
        $(document).on('click', '#app_data_tables_front_store_item_maintenance_item_data_tablein_process_wrapper .btn-cancel', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Cancel Maintenance', 'Are you sure you want to cancel maintenance on this item?', function (resp) {
                if (resp) {
                    abcsetup.dashboard.vendor.item_maintenance.delete(_this.data('id'), _this.data('type'));
                }
            });
        });

        // New item in process - delete button clicked
        $(document).on('click', '#three_pm_panel .btn-delete', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Delete Item', 'Are you sure you want to delete this import?', function (resp) {
                if (resp) {
                    abcsetup.dashboard.vendor.three_pm.delete(_this.data('id'));
                }
            });
        });

        // pr_docs Decline event handlers
        $(document).on('click', '.dropdown-menu.pr_doc_request_decline', function (event) {
            event.stopPropagation();
        });

        $(document).on('click', 'button.pr_doc_request_decline', function () {
            abcsetup.dashboard.vendor.prdocs.decline(this);
        });

        // pr_docs Decline event handlers
        $(document).on('click', '.dropdown-menu.pr_doc_reminder_update', function(event) {
            // prevent datatable row from being toggled
            event.stopPropagation();
        });

        $(document).on('click', 'button.pr_doc_reminder_update', function () {
            abcsetup.dashboard.vendor.prdocs.update(this);
        });

        // pr_doc reminder Other reason event handler
        $(document).on('click', "input[name='pr_doc_reminder_decline_reasons[]'][value='Other:']", function (event) {
            $(this).siblings(".pr_doc_reminder_decline_reason_other_comment").toggle().val("");
        });

        $(document).on('click', '.image_request_decline_btn_group', event => event.stopPropagation());
        $(document).on('click', 'button.image_request_decline_confirm_btn', function () {
            abcsetup.dashboard.vendor.image_requests.decline(this);
        });

        $(document).on('click', '.image_request_decline_btn_group [type=checkbox]', function () {
            $(this).parents('.dropdown-menu').find('.errorMsg').remove();
            $(this).parents('.dropdown-menu').find('.invalid').removeClass('invalid');
        });

        $(document).on('click', '.image_request_decline_btn_group [type=checkbox].other', function () {
            $(this).parents('.dropdown-menu').find('.other_comment').toggle().val("");
        });

        $(document).on('click', '.btn.promo_plan',function(e) {

            e.preventDefault();
            // if (==null || promo_plpromo_planan.vendor_terms_accepted=="NO") {
            $('#promo_plan-modal .modal-title').html('Promotional Plan Terms and Condition');
            $('#promo_plan-modal').modal('show');
            $('button#promo_plan_term_accept').attr('data-href',$(this).attr('href'));
            // }
        });

        $(document).on('click', 'button#promo_plan_term_decline',function(e) {
            window.location.href = '/promo_plan/vendor_terms_decline'
        })

        $(document).on('click', 'button#promo_plan_term_accept',function(e) {
            if ($(this).attr('data-href')) {
                window.location.href = $(this).attr('data-href')+"?promo_plan_term_accept=YES";
            }
        })

        $(document).on('click', '.pop.promo_type',function(e) {
            abcsetup.blockUI(true);

            axios.get('/api/proof_of_performance/' + $(this).data('promo_type')).then(response => {
                $('#events_panel').find('#proof_of_performance table, #proof_of_performance .dataTables_wrapper').remove();
                abcsetup.unblockUI();

                if (response.data.table_data) {
                    $('#events_panel').find('#proof_of_performance').html(response.data.table_data);
                    $('#events_panel').find('#proof_of_performance').find('#' + response.data.table_id).addClass('table-sm');

                    // Init datatables
                    abcsetup.datatables.client_side.init($('#events_panel').find('#' + response.data.table_id), {
                        "remove": [0],
                        bInfo: true,
                        "lengthMenu": [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, 'All']],
                        "iDisplayLength": 5,
                        "order": [[2, "desc"]],
                        "responsive": true,
                        "extraBtns": [
                            '<a href="#" class="btn btn-warning tooltips ml-2 pop_go_back btn-sm" title="Click to go back">Back</a>',
                        ],
                    });
                }
            });
        })

        $(document).on('click', '.pop_go_back', function (e) {
            window.location.reload();
        });

        // PR Doc decline all modal
        $(document).on('click', '.decline-all', function() {
            // popup containing all the pr doc requests
            // with checkboxes
            axios.get('/api/pr_docs/decline/all').then(response => {
                $(response.data).modal('show');
            }).catch(error => {
                alert('Error booting decline all modal.');
            });
        });

        // PR Doc decline all
        $(document).on('click','#pr_doc_decline_all-modal .btn.pr_doc_request_decline-all', function(){
            // popup containing all the pr doc requests
            // with checkboxes
            var checked_reasons = $("#decline-all-pr-docs").find('input[name="pr_doc_reminder_decline_reasons[]"]:checked');
            if (checked_reasons.length == 0) {
                abcsetup.alerts.show('Decline Error', 'Please select at least 1 reason to decline the request');
                return false;
            }
            if ($("#decline-all-pr-docs").find("input[name='pr_doc_reminder_decline_reasons[]'][value='Other:']").is(":checked")) {
                if (!$("#decline-all-pr-docs").find(".pr_doc_reminder_decline_reason_other_comment").val()) {
                    abcsetup.alerts.show('Decline Error', 'Please enter the other reason comment');
                    return false;
                }
            }

            axios.put('/api/pr_docs/decline/all', $('#decline-all-pr-docs').serialize()).then(response => {
                // remove the modal
                $('#pr_doc_decline_all-modal .close').trigger('click');
                $('#pr_doc_decline_all-modal').remove();
                $('.modal-backdrop').remove();
                // show the response text
                abcsetup.alerts.flashMessage(response.data);
                // refresh the pr doc table
                $('#app_data_tables_pr_docs_outstanding_data_table').DataTable().clear().draw();
            }).catch(error => {
            });
        });

        if (abcsetup.getUrlParameter('tab') == 'price_change') {
            setTimeout(function() {
                $('#price_change_tab').trigger('click');
            }, 500);
        }

        this.rfp.init();
        this.three_pm.init();
        this.ncm.init();
    },


    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  Frontstore Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    frontstore: {
        /**
         *
         */
        deleteWorkflow: function(id, reasonText = '') {
            abcsetup.blockUI(true);
            abcsetup.dashboard.showLoading($('#outstanding_panel'));
            $('#outstanding_panel').find('.dataTables_wrapper').hide();

            axios.delete('/api/workflow_task/' + id, {data: {reason: reasonText}}).then(response => {
                window.location.reload();
            });
        },

        /**
         *
         */
        delete: function (id) {
            abcsetup.blockUI(true);
            abcsetup.dashboard.showLoading($('#new_items_panel'));
            $('#new_items_panel').find('.dataTables_wrapper').hide();

            axios.delete('/front_store/' + id).then(response => {
                window.location.reload();
            });
        },
    },


    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  PR Doc Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    prdocs: {
        /**
         * Call ajax /api/pr_docs/decline
         * @param {Object} e - Decline button element clicked
         */
        decline: function (e) {
            var _e = $(e);
            var dropdown = _e.closest('.dropdown-menu.pr_doc_request_decline');
            var pr_doc_reminder = _e.data('pr_doc_reminder')
            var checked_reasons = dropdown.find('input:checkbox:checked');

            if (checked_reasons.length == 0) {
                abcsetup.alerts.show('Decline Error', 'Please select at least 1 reason to decline the request');
                return false;
            }

            if (dropdown.find("input[name='pr_doc_reminder_decline_reasons[]'][value='Other:']").is(":checked")) {
                if (!dropdown.find(".pr_doc_reminder_decline_reason_other_comment").val()) {
                    abcsetup.alerts.show('Decline Error', 'Please enter the other reason comment');
                    return false;
                }
            }

            abcsetup.blockUI(true);

            axios.put('/api/pr_docs/decline/' + pr_doc_reminder, dropdown.find("form").serialize()).then(response => {
                console.log(JSON.stringify(response.data, {}, 4));
                $(dropdown).dropdown('toggle');
                // NOTE:  we *could* have done a tr.hide() for the row containing the declined record,
                // but we rather want to refresh the datatable. However, we can only do this by calling
                // prdocs.outstanding() as there is no ajax attribute associated with the datatable
                // object which would otherwise have allowed us to call
                // abcsetup.dashboard.vendor.prdocs.datatable.ajax.reload() - hence, this forces
                // a reload of the entire #pr_doc_items element
                window.location.reload();
            });
        },
        /**
         * Call ajax /api/pr_docs/update
         * @param {Object} e - Update button element clicked
         */
        update: function(e) {
            var _e = $(e);
            var dropdown = _e.closest('.dropdown-menu.pr_doc_request_update');
            var pr_doc_reminder = _e.data('pr_doc_reminder')
            var interval = dropdown.find('input.pr_doc_reminder_interval');

            axios.put('/api/pr_docs/update/' + pr_doc_reminder,dropdown.find("form").serialize()).then(response => {
                console.log(JSON.stringify(response.data,{},4));
                $(dropdown).dropdown('toggle');
                // NOTE:  We want to refresh the datatable. However, we can only do this by calling
                // prdocs.outstanding() as there is no ajax attribute associated with the datatable
                // object which would otherwise have allowed us to call
                // abcsetup.dashboard.vendor.prdocs.datatable.ajax.reload() - hence, this forces
                // a reload of the entire #pr_doc_items element
                window.location.reload();
            });
        },
    },


    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  Item Image Requests
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    image_requests: {
        /**
         * Call ajax /api/pr_docs/decline
         * @param {HTMLButtonElement} declineButton
         * @returns {boolean}
         */
        decline(declineButton) {
            declineButton = $(declineButton);
            const dropdown = declineButton.closest('.dropdown-menu');
            const imageRequestId = declineButton.data('image_request_id');
            const checkedReasons = dropdown.find('input:checkbox:checked');
            dropdown.find('.errorMsg').remove();

            if (checkedReasons.length === 0) {
                declineButton.before('<div class="errorMsg mb-2"><small class="text-danger">Please select at least 1 reason to decline the request</small></div>');
                return false;
            }

            console.log('imageRequestId: ',imageRequestId);
            console.log('checkedReasons: ', checkedReasons.toArray());

            fieldValidate.runValidations(dropdown.find('form'))
                .then(() => {
                    if (fieldValidate.checkValidity(dropdown.find('form'))) {
                        abcsetup.blockUI(true);
                        axios.delete(
                            '/api/image_collection/item_image_request/' + imageRequestId,
                            {
                                data: {
                                    decline_reasons: checkedReasons.toArray().map(checkbox => checkbox.value),
                                    other_comment: dropdown.find(':input.other_comment').val(),
                                }
                            }
                        ).then(() => {
                            $(dropdown).dropdown('toggle');
                            window.location.reload();
                        });
                    }
                });
        },
    },


    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  Item Maintenance Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    item_maintenance: {
        /**
         *
         */
        delete: function (id, type) {
            abcsetup.blockUI(true);
            abcsetup.dashboard.showLoading($('#new_items_panel'));
            $('#new_items_panel').find('.dataTables_wrapper').hide();

            $.ajax({
                type: "POST",
                url: "/front_store/maintenance/" + id + "/cancel",
                cache: false,
                success: function (data) {
                    window.location.reload();
                }
            });
        },
    },

    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  RFP Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    rfp: {
        init() {
            abcsetup.dashboard.common.vendor.init();
        },
    },


    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  Promo Plan Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    promo_plans: {
        /*
         *
         */
         delete: function (id) {
            abcsetup.blockUI(true);
            abcsetup.dashboard.showLoading($('#events_panel'));
            $('#events_panel').find('#promo_plans table, #promo_plans .dataTables_wrapper').hide();

            axios.delete('/api/promos/plans/' + id).then(response => {
                window.location.reload();
            });
        },
    },

    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  3PM Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////

    three_pm: {
        init: function () {
            /**
             *
             */
            abcsetup.dashboard.vendor.three_pm.updateTimer = setInterval(function() {
                $("#app_data_tables_three_p_m_in_process_data_table_wrapper tbody tr div.status").each(function() {
                    var status_element = $(this);
                    var id = status_element.data("id");
                    var status = status_element.attr("data-status");
                    //console.log("id:status:"+id+":"+status)
                    var row = status_element.closest('tr');

                    var rows_imported_element = row.find(".rows_imported");
                    var rows_element = row.find(".rows");
                    var failed_items_element = row.find(".failed_items");
                    var built_items_element = row.find(".built_items");

                    if (!id || !status) {
                        console.log('poll_import_item: invalid id/status');
                        return;
                    }

                    if (status != 'error' && status != 'success') {
                        if (status == 'building'){
                            //console.log(id+":"+status);
                            row.find('a').addClass('disable-click')
                            axios.get("/api/three_pm_import/record/"+id+"?build=1").then(result => {
                                // console.log("/api/three_pm_import/record: result"+JSON.stringify(result,{},4));
                                if (result.data) {
                                    var imported_count = parseInt(rows_imported_element.html());
                                    var total_count = parseInt(result.data.fail_count) + parseInt(result.data.success_count);
                                    if (parseInt(result.data.fail_count)>0)
                                        failed_items_element.html('<div class="alert alert-danger">'+result.data.fail_count+'</div>');
                                    else
                                        failed_items_element.html(result.data.fail_count);

                                    if (parseInt(result.data.success_count)>0)
                                        built_items_element.html('<div class="alert alert-success">'+result.data.success_count+'</div>');
                                    else
                                        built_items_element.html(result.data.success_count);

                                    if (total_count == imported_count) {
                                        row.find('a').removeClass('disable-click');
                                        status_element.removeClass("alert-info").addClass("alert-success");
                                        status_element.html("Built");
                                        status_element.attr("data-status","success");
                                    } else {
                                        // Items are still building
                                    }
                                } else {
                                    clearInterval(abcsetup.dashboard.vendor.three_pm.updateTimer);
                                }
                            });
                        } else {
                            //console.log(id+":"+status);
                            row.find('a').addClass('disable-click')
                            axios.get("/api/three_pm_import/record/"+id).then(result => {
                                // console.log("/api/three_pm_import/record: result"+JSON.stringify(result,{},4));
                                if (result.data){
                                    if (result.data.status == 'error') {
                                        status_element.removeClass("alert-info").addClass("alert-danger");
                                    }
                                    else if (result.data.status == 'success') {
                                        status_element.removeClass("alert-info").addClass("alert-success");
                                    }

                                    status_element.attr("data-status",result.data.status);
                                    status_element.attr("data-rows",result.data.data_rows_imported);
                                    rows_imported_element.html(result.data.data_rows_imported);
                                    rows_element.html(result.data.rows);

                                    if (result.data.status == 'error' || result.data.status == 'success') {
                                        row.find('a').removeClass('disable-click');
                                        status_element.html(result.data.import_item_status.name);
                                    } else {
                                        status_element.find(".status_text").html(result.data.import_item_status.name);
                                    }
                                }
                            });
                        }
                    }
                });
            }, 2000);
        },

        /**
         *
         */
        delete: function (id) {
            abcsetup.dashboard.showLoading($('#three_pm_panel'));
            $('#three_pm_panel').find('.dataTables_wrapper').hide();

            axios.delete('/three_pm_import/' + id).then(response => {
                window.location.reload()
            });
        },
    },

    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  Large Customer Opportunity Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////

    ncm: {
        init: function() {
            const ncmToggle = $('.bhoechie-tab-content:has(#ncm_tables) .btn-group-toggle');
            ncmToggle.on('click', event => {
                $(`.bhoechie-tab-content:has(#ncm_tables) .ncm_table`).hide();
                $(`.bhoechie-tab-content:has(#ncm_tables) .${event.target.value}_table`).show();
            });
        },
    },
}
